import { render } from "./LogoutMenu.vue?vue&type=template&id=404af7d8&scoped=true"
import script from "./LogoutMenu.vue?vue&type=script&lang=js"
export * from "./LogoutMenu.vue?vue&type=script&lang=js"

import "./LogoutMenu.vue?vue&type=style&index=0&id=404af7d8&scoped=true&lang=less"

import exportComponent from "/home/digital_profile_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404af7d8"]])

export default __exports__